export function Loader() {
  return (
    <div className="min-h-[200px] flex items-center justify-center">
      <div className="sc-loader-big w-20 h-20"></div>
    </div>
  )
}
